import DeliveryDiningOutlinedIcon from "@mui/icons-material/DeliveryDiningOutlined";
import FactoryIcon from "@mui/icons-material/Factory";

export function PumppuToimittajaIcon(props) {
  return <DeliveryDiningOutlinedIcon color="primary" {...props} />;
}

export function BetoniToimittajaIcon(props) {
  return <FactoryIcon color="primary" {...props} />;
}
